module.exports = __webpack_public_path__ + "static/img/idcard-frontend.82e2503f.png";